// extracted by mini-css-extract-plugin
export default {"portal":"portal_portal__4Fhjg"};